import type { Category } from '@scayle/storefront-api'

export const useFimCategories = (
  categories: Category[] | Category | undefined,
  selectedCategory: MaybeRefOrGetter<Category | undefined>,
) => {
  const route = useRoute()
  const key = `categories.value-${route.path}')`
  const flattenedCategories = useState(key, () =>
    Array.isArray(categories)
      ? flattenCategories(categories)
      : categories
        ? [categories]
        : [],
  )

  const categoryHeadline = computed(() =>
    getCategoryHeadline(selectedCategory, categories),
  )

  const getCategoryBySlug = (slug?: string) => {
    if (!slug) {
      return undefined
    }

    return flattenedCategories.value.find(
      (category) => category.slug.toLowerCase() === slug.toLowerCase(),
    )
  }

  return { flattenedCategories, categoryHeadline, getCategoryBySlug }
}
